import { Component } from '@angular/core';
import { NotificationData } from '../../notification-list-item/notification-list-item.component';

@Component({
  selector: 'app-notification-list-item-showcase',
  templateUrl: './notification-list-item-showcase.component.html',
  styleUrls: ['./notification-list-item-showcase.component.scss']
})
export class NotificationListItemShowcaseComponent {
  removedItems = new Set<number>();

  simpleMessage = {
    id: 1,
    message: 'Simple notification message',
    viewed: true,
    category: 'WELCOME_LEADER'
  };

  messageWithLink = {
    id: 2,
    message: 'Check this out: <a href="#" target="_blank">Click here for details</a>',
    viewed: true,
    category: 'NEW_CHALLENGE'
  };

  longMessage = {
    id: 3,
    message: 'This is a longer notification message that contains more information about the action that was taken. It may wrap to multiple lines and should still display correctly with proper spacing and alignment.',
    viewed: true,
    category: 'CHALLENGE_COMPLETED'
  };

  welcomeLeader = {
    id: 1001,
    message: 'Welcome to the program',
    viewed: true,
    category: 'WELCOME_LEADER'
  };

  challengeCompleted = {
    id: 1002,
    message: 'Congratulations! You have completed the challenge.',
    viewed: true,
    category: 'CHALLENGE_COMPLETED'
  };

  newChallenge = {
    id: 1003,
    message: 'A new challenge has been assigned to you.',
    viewed: true,
    category: 'NEW_CHALLENGE'
  };

  roleAssignment = {
    id: 1004,
    message: 'Your role has been updated by administrator.',
    viewed: false,
    category: 'ROLE_ASSIGNMENT'
  };

  sampleNotifications: NotificationData[] = [
    {
      id: 82862,
      message: 'Learn what you can do as a Partner Leader in Seller Rewards. <a href="https://sellerrewards-datahandler.cisco.com/shared/leaderOverviewVideo" target="_blank">Click here</a>',
      viewed: true,
      category: 'WELCOME_LEADER'
    },
    {
      id: 260693,
      message: '50000 challenge has been completed. Check out challenges.',
      viewed: true,
      category: 'CHALLENGE_COMPLETED'
    },
    {
      id: 260470,
      message: '1000 challenge has been completed. Check out challenges.',
      viewed: false,
      category: 'CHALLENGE_COMPLETED'
    },
    {
      id: 260447,
      message: 'Your company has assigned you a new Challenge to earn Seller Rewards tickets. Get started now.',
      viewed: true,
      category: 'NEW_CHALLENGE'
    },
    {
      id: 260370,
      message: 'You have been assigned the designated Administrator role by your company administrator.',
      viewed: false,
      category: 'ROLE_ASSIGNMENT'
    }
  ];

  onRemove(id: number): void {
    this.removedItems.add(id);
  }

  isRemoved(id: number): boolean {
    return this.removedItems.has(id);
  }

  reset(): void {
    this.removedItems.clear();
  }
}
